import { useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * Toggles the `dt` (default theme) body class off for `/public` pages. The `Spin`
 * indicator is no longer set here: `UIProvider` supplies it through ConfigProvider so it
 * applies on the first render rather than after this effect.
 */
export function useBodyClass() {
    const location = useLocation();

    useEffect(() => {
        const body = document.body;
        const isPublicPath = location.pathname.includes('/public');

        if (isPublicPath) {
            // Remove "dt" - default theme class if path includes /public
            body.classList.remove('dt');
        } else {
            // Add "dt" class if path doesn't include /public
            body.classList.add('dt');
        }

        // Cleanup function to remove the class when component unmounts
        return () => {
            body.classList.remove('dt');
        };
    }, [location.pathname]);
}
